import React, { FC } from 'react'

import { CardProps } from '../../../components/Card'
import { ActionButtonProps } from '../../../components/ActionButton'
import BoxedContent from '../../../components/BoxedContent'

import * as SC from './styled'

export type HomeProps = {
  className?: string
  background: string
  header: CardProps['header']
  content: {
    title: string
    button: ActionButtonProps
  }
}

const Home: FC<HomeProps> = ({ className, background, header, content: { title, button } }) => {
  return (
    <SC.Container className={className} $background={background}>
      <BoxedContent>
        <SC.CardWrapper className={className} header={header}>
          <SC.Title>{title}</SC.Title>
          <SC.HomeButton {...button} />
        </SC.CardWrapper>
      </BoxedContent>
    </SC.Container>
  )
}

export default Home
